import { render, staticRenderFns } from "./TirePressureList.vue?vue&type=template&id=2b7d6a2e&scoped=true"
import script from "./TirePressureList.vue?vue&type=script&lang=js"
export * from "./TirePressureList.vue?vue&type=script&lang=js"
import style0 from "./TirePressureList.vue?vue&type=style&index=0&id=2b7d6a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d6a2e",
  null
  
)

export default component.exports